<h3 class="ngx-dialog__subtitle" *ngIf="data.subtitle">{{ data.subtitle }}</h3>
<ng-container *ngIf="data.content && data.content.length">
<mat-dialog-content >
  <ng-container *ngFor="let content of data.content">
    <h1 mat-dialog-title class="p--0 mb--16">{{ content.promo_title }}</h1>
    <div [innerHTML]="content.promo_text | translate">
    </div>
  </ng-container>
</mat-dialog-content>
</ng-container>
<mat-dialog-actions class="p--24">
    <ng-container *ngIf="data.buttons; else noButtons">
      <ng-container *ngFor="let button of data.buttons; let i = index">
        <button
          mat-button
          cdkFocusInitial
          [mat-dialog-close]="button.value">
          {{ button.text | translate }}
        </button>
        <mat-divider [vertical]="true" class="mr--16 ml--16"></mat-divider>
      </ng-container>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
  </ng-container>
  </mat-dialog-actions>
<ng-template #noButtons>
  <button mat-flat-button mat-dialog-close="confirm" color="primary">{{ 'Confirm' | translate }}</button>
   <button mat-flat-button mat-dialog-close="cancel" color="warn">{{ 'Cancel' | translate }}</button>
</ng-template>